import React from 'react';
import {DragSource} from 'react-dnd';
import ItemTypes from './sections/tab_dnd/dnd_types'
import {connect} from "react-redux";
import {addNewSection} from "./actions";
import {withStyles, Tooltip} from 'material-ui';
import {builderStyles} from './style/builder';

const sectionSource = {

    canDrag(props) {
        return props.isReady;
    },

    isDragging(props, monitor) {
        return monitor.getItem().id === props.id;
    },

    beginDrag(props, monitor, component) {
        return {id: props.id, type: props.text };
    },

    endDrag(props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }
        const item = monitor.getItem();
        const dropResult = monitor.getDropResult();
        if (dropResult) {
            props.addNewSection(props.pageId, item.id, item.type, dropResult.index);
        }
    }
};

const collect = (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
});

class AvailableElement extends React.Component {
    render() {
        const {text, classes} = this.props;

        const {isDragging, connectDragSource} = this.props;

        let textItem = text;

        if (isDragging) {
            textItem += ' ... ';
        }

        let elementImagePath = process.env.PUBLIC_URL +
            `/assets/pagebuilder/element-${this.props.id}.svg`;

        return connectDragSource(
            <div>
                <Tooltip title="Click anywhere on this box and move the mouse in order to Drag &amp; Drop a new section">
                    <img
                        className={classes.pbElementImage}
                        src={elementImagePath}
                        alt="Projects Abroad"
                    />
                </Tooltip>
                <p className={classes.pbElementText}>
                    {textItem}
                </p>
            </div>
        );
    }
}

const availableDragSource = DragSource(
    ItemTypes.AVAILABLE_SECTION, sectionSource, collect
)(AvailableElement);

export default connect(
    null, {addNewSection: addNewSection }
)(withStyles(builderStyles)(availableDragSource));


// WEBPACK FOOTER //
// ./src/containers/builder/elements.js